var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancelReservationArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 15,
    viewBox: "0 0 33 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 15.0039,
    height: 15.001,
    rx: 1.87512,
    transform: "matrix(-1 0 0 1 15.0039 0)",
    fill: "#1C1C1E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8711 7.49486C15.8711 6.91953 15.8209 6.45312 15.759 6.45312H6.36531C6.30341 6.45312 6.25323 6.91953 6.25323 7.49486C6.25323 8.07019 6.30341 8.5366 6.36531 8.5366H15.759C15.8209 8.5366 15.8711 8.07019 15.8711 7.49486Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0837 1.98321C9.82545 1.70351 9.40678 1.70351 9.14856 1.98321L4.51996 6.99656C4.26174 7.27625 4.26174 7.72972 4.51996 8.00941L9.14856 13.0228C9.40678 13.3025 9.82545 13.3025 10.0837 13.0228C10.3419 12.7431 10.3419 12.2896 10.0837 12.0099L5.92264 7.50298L10.0837 2.99606C10.3419 2.71636 10.3419 2.2629 10.0837 1.98321Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.0273 7.50008C32.0273 6.80968 31.937 6.25 31.8256 6.25H14.9169C14.8055 6.25 14.7152 6.80968 14.7152 7.50008C14.7152 8.19048 14.8055 8.75016 14.9169 8.75016H31.8256C31.937 8.75016 32.0273 8.19048 32.0273 7.50008Z",
    fill: "#1C1C1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelReservationArrowIcon);
export default __webpack_public_path__ + "static/media/cancel-reservation-arrow-icon.bdba4a30142912446b20ddcbd6d5112f.svg";
export { ForwardRef as ReactComponent };